"use client";

import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { SearchIcon } from "lucide-react";
import { SearchInputWithSuggestions } from "./search-input-with-suggestions";

interface SearchPillProps {
	channel: string;
	locale: string;
}

export function SearchPill({ channel, locale }: SearchPillProps) {
	const t = useTranslations("nav");
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		function handle(e: KeyboardEvent) {
			if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
				const input = containerRef.current?.querySelector("input");
				if (!input) return;
				e.preventDefault();
				input.focus();
			}
		}
		window.addEventListener("keydown", handle);
		return () => window.removeEventListener("keydown", handle);
	}, []);

	return (
		<div
			ref={containerRef}
			className="group/searchpill bg-foreground/[0.04] border-foreground/[0.10] relative flex min-w-0 flex-1 items-center gap-2 rounded-full border px-4 py-2 transition-colors focus-within:border-transparent focus-within:bg-card focus-within:shadow-[inset_0_0_0_1px_var(--primary)]"
		>
			<SearchIcon className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
			<SearchInputWithSuggestions
				channel={channel}
				locale={locale}
				placeholder={t("searchPlaceholder")}
				variant="pill"
			/>
			<kbd className="bg-foreground/[0.06] pointer-events-none hidden shrink-0 rounded px-1.5 py-[2px] font-mono text-[10px] text-muted-foreground lg:inline-flex">
				⌘K
			</kbd>
		</div>
	);
}
